module.exports = __webpack_public_path__ + "img/info.7a25dd51.svg";